import dayjs from 'dayjs';

function ruleName(original) {
  return original?.ruleName || '';
}

function ruleResult(original) {
  return original?.ruleResult ? 'Passed' : 'Failed';
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original.createdDateTime).format('MMM D, YYYY h:mm a')
    : '';
}
export { ruleName, ruleResult, createdDateTime };
